import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { UserGroupsVM } from './user-groups.viewmodel';

const UserGroupsContext = React.createContext<UserGroupsVM>(null);
const connectUserGroupsVM = makeConnect(UserGroupsContext);

export { UserGroupsContext, connectUserGroupsVM };
